import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';

//components
import {UserInfoComponent} from '../ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../ControlGroups/GeneralDetails.component';
import {PaperworkOnlyMoveDetailsComponent} from '../ControlGroups/PaperworkOnlyMoveDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../Employees/ChangePhoneNumberDialog.component';

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-paperwork-only-move-request',
  templateUrl: './CreatePaperworkOnlyMoveRequest.component.html'
})
export class CreatePaperworkOnlyMoveRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    activityReasonFilter: filters.ActivityReasonFilter;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(PaperworkOnlyMoveDetailsComponent) paperworkOnlyMoveDetailsComponent: PaperworkOnlyMoveDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    { 
        super();
        
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        
        this.userInfo = this.authenticationService.getUserInfo();
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.PaperworkOnlyMove,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.PaperworkOnlyMoveLineItems = this.paperworkOnlyMoveDetailsComponent.paperworkOnlyMoveLineItemGridComponent.lineItems;
        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);
    }

    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onLineItemsChanged(event: number){
        
    }

}
